import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./context/CartContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import WholesalePage from "./pages/WholesalePage";
import FlavorsPage from "./pages/FlavorsPage";
import UVCottonCandyPage from "./pages/UVCottonCandyPage";
import EventsPage from "./pages/EventsPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-[#FFFCF9]">
        <CartProvider>
          <BrowserRouter>
            <Navbar />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/wholesale" element={<WholesalePage />} />
              <Route path="/flavors" element={<FlavorsPage />} />
              <Route path="/uv-cotton-candy" element={<UVCottonCandyPage />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              {/* Redirect old URLs */}
              <Route path="/bundles" element={<Navigate to="/wholesale" replace />} />
              <Route path="/bulk-orders" element={<Navigate to="/wholesale" replace />} />
              <Route path="/fundraisers" element={<Navigate to="/wholesale" replace />} />
              <Route path="/collections/*" element={<Navigate to="/flavors" replace />} />
            </Routes>
            <Footer />
            <Toaster position="top-center" richColors />
          </BrowserRouter>
        </CartProvider>
      </div>
    </HelmetProvider>
  );
}

export default App;
